import React from 'react';
import './Background.css';

const Background = () => {
    return (
        <div>
            <div>
                <div className="wave"></div>
                <div className="wave"></div>
                <div className="wave"></div>
            </div>
        </div>
    );
};

export default Background;
